<template>
  <div>
    <v-data-table
      class="rating-table"
      :headers="headers"
      :loading="loading"
      :items="items"
      :items-per-page="-1"
      hide-default-footer
    >
      <!-- <template #header>
        <thead class="v-data-table-header">
          <tr>
            <th>{{ $t('roles.role-name') }}</th>
            <th>{{ $t('common.points') }}</th>
            <th style="text-align:center" width="150px">
              <v-btn
                elevation="0"
                small
                @click="
                  () => {
                    dialog.opened = true;
                    dialog.editData = null;
                  }
                "
                >{{ $t('common.button.add') }}</v-btn
              >
            </th>
          </tr>
        </thead>
      </template> -->

      <template #[`header.actions`]>
        <v-btn
          elevation="0"
          small
          @click="
            () => {
              dialog.opened = true;
              dialog.editData = null;
            }
          "
        >
          {{ $t('common.button.add') }}
        </v-btn>
      </template>

      <template #item="{ item }">
        <tr>
          <td>
            <button
              class="edit-btn"
              @click="
                () => {
                  dialog.opened = true;
                  dialog.editData = item;
                }
              "
            >
              {{ item.name }}
            </button>
          </td>
          <td>{{ item.score }}</td>
          <td />
        </tr>
      </template>

      <template #no-data>
        {{ $t('common.fields.noData') }}
      </template>
    </v-data-table>

    <rating-configurator-dialog
      v-model="dialog.opened"
      :category-name="title"
      :only-numbers-name="onlyNumbersName"
      :type="type"
      :edit-data="dialog.editData"
      @updated="$emit('updated', $event)"
    />
  </div>
</template>

<script>
import RatingConfiguratorDialog from './RatingConfiguratorDialog.vue';

export default {
  components: { RatingConfiguratorDialog },
  props: {
    title: {
      type: String,
      default: '',
    },
    onlyNumbersName: {
      type: Boolean,
      default: false,
    },
    type: {
      type: Number,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dialog: {
      opened: false,
      editData: null,
    },
  }),
  computed: {
    headers() {
      return [
        { text: this.$t('roles.role-name'), value: 'name', sortable: false },
        { text: this.$t('common.points'), value: 'score', sortable: true },
        { text: '', value: 'actions', sortable: false },
      ];
    },
    items() {
      const { configuratorList } = this.$store.state.driver;
      return configuratorList.filter(({ type }) => type === this.type);
    },
  },
};
</script>

<style lang="scss">
.rating-table {
  .v-data-table__wrapper {
    border-radius: 0 !important;
  }

  .v-data-table-header th:last-child {
    width: 150px;
  }

  .edit-btn {
    text-align: left;
    font-size: 14px;
    font-weight: 600;
    color: #464646;
    line-height: 1.3;
    text-decoration: none;

    &[disabled] {
      font-weight: normal;
    }

    &:not([disabled]):hover {
      opacity: 0.7;
    }
  }
}
</style>
